import useAuth from "../../../auth/useAuth";
import { userCompanyListRoute } from "../../../config";
import { useFetchGET } from "../../../state/FetchHelpers";

export const useUserCompaniesDataById = (reloadData, id_user) => {
    const auth = useAuth();
    const token = auth.globals.token;
    auth.globals.id.toString()
    
    const { data: userCompanyListData, loading: userCompanyListLoading, error: userCompanyListError } = useFetchGET(id_user != null ? userCompanyListRoute(id_user) : undefined, token, [], reloadData);

    return {
        //properties
        userCompanyListData,
        userCompanyListLoading,
        userCompanyListError
    }
}